<template>
  <div class="col-md-12 airalo_simcard_list">
    <div
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="form_select">
        <label> {{ translate('airalo.status') }} </label>
        <tree-select
            :options="status_list"
            :multiple="false"
            v-model="filter.active"
            :placeholder="translate('airalo.status')"
            :clearable="true"
            :searchable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <fg-input
            v-model="filter.package_id"
            type="text"
            :placeholder="translate('airalo.package_id')"
            :label="translate('airalo.package_id')"
            :clearable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <fg-input
            v-model="filter.apn_value"
            type="text"
            :placeholder="translate('airalo.apn_value')"
            :label="translate('airalo.apn_value')"
            :clearable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <fg-input
            v-model="filter.order_id"
            type="text"
            :placeholder="translate('airalo.order_id')"
            :label="translate('airalo.order_id')"
            :clearable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select">
        <label> {{ translate('airalo.options') }} </label>
        <tree-select
            :options="option_list"
            :multiple="true"
            v-model="options"
            :placeholder="translate('airalo.options')"
            :clearable="true"
            :searchable="true"
            @input="change_input"
        />
      </div>

      <div class="form_select"></div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="summary.length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("airalo.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>

      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer name"
                @click="change_filter('airalo_simcard_id')"
                :class="{ selected: filter_type === 'airalo_simcard_id' }"
                scope="col"
            >
              {{ translate('airalo.airalo_simcard_id') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('active')"
                :class="{ selected: filter_type === 'active' }"
                scope="col"
            >
              {{ translate('airalo.status') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('package_id')"
                :class="{ selected: filter_type === 'package_id' }"
                scope="col"
            >
              {{ translate('airalo.package_id') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('order_id')"
                :class="{ selected: filter_type === 'order_id' }"
                scope="col"
            >
              {{ translate('airalo.order_id') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('iccid')"
                :class="{ selected: filter_type === 'iccid' }"
                scope="col"
            >
              {{ translate('airalo.iccid') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('apn_value')"
                :class="{ selected: filter_type === 'apn_value' }"
                scope="col"
            >
              {{ translate('airalo.apn_value') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name w60"
                @click="change_filter('is_unlimited')"
                :class="{ selected: filter_type === 'is_unlimited' }"
                scope="col"
            >
              {{ translate('airalo.is_unlimited') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('expired_at')"
                :class="{ selected: filter_type === 'expired_at' }"
                scope="col"
            >
              {{ translate('airalo.expires') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>


            <th
                class="pointer name"
                @click="change_filter('ts_create')"
                :class="{ selected: filter_type === 'ts_create' }"
                scope="col"
            >
              {{ translate('airalo.purchased') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>

            <th
                class="pointer name"
                @click="change_filter('ts_update')"
                :class="{ selected: filter_type === 'ts_update' }"
                scope="col"
            >
              {{ translate('airalo.ts_update') }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
            </th>
            <th style="width: 5px"></th>
          </tr>
        </thead>
        <tbody>
          <AiraloSimcardItem
              v-for="(airalo_simcard,key) in airalo_simcards"
              :key="key"
              :airalo_simcard="airalo_simcard"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AiraloSimcardItem from "./Item/Index.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'AiraloSimcardList',
  components: {
    WrapDatePicker,
    AiraloSimcardItem
  },
  data () {
    return {
      airalo_simcard_list: [],
      check_link: true,
      filter:{
        active: null,
        package_id: "",
        apn_value: "",
        order_id: "",
        is_unlimited: null,
        limited: null,
        expired_at: null
      },
      options: [],
      filter_asc: "asc",
      filter_type: "",
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    sended_filter() {
      let filter = {};
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
          filter[key] = this.filter[key]
        }
      })
      return filter;
    },
    status_list() {
      return [
        {id: 0, label: this.translate("airalo.filter.not_active")},
        {id: 1, label: this.translate("airalo.filter.active")},
      ]
    },
    option_list() {
      return [
        {id: "is_unlimited", label: this.translate("airalo.filter.unlimited")},
        {id: "limited", label: this.translate("airalo.filter.limited")},
        {id: "expired_at", label: this.translate("airalo.filter.expired")},
      ]
    },
    airalo_simcards(){
      let airalo_simcards = [...this.airalo_simcard_list];
      return airalo_simcards.sort(this.compareNumbers);
    },
  },

  watch:{
    options:{
      deep: true,
      handler(){
        this.option_list.forEach((option) =>{
          if (this.options.indexOf(option.id) > -1){
            this.filter[option.id] = 1
          } else {
            this.filter[option.id] = null
          }
        })
      }
    },
  },

  created () {
    this.load_airalo_simcards()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_airalo_simcards, 500)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
              this.filter.client_id = this.$route.query[key]
              break;
            }
        }
      }
    },
    load_airalo_simcards(){
      this.$http.simcard.getAiraloSimcards(this.sended_filter, (response) => {
        if (response.data){
          this.airalo_simcard_list = response.data.data
          this.summary = response.data.summary
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>

.airalo_simcard_list{
  height: 100%;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
    }
  }

  .airalo_simcard{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
  }
  .response_table{
    flex: 10;
    padding: 10px 0 0;
    table{
      tbody{
        .online{
          color: #15ab00;
        }
        span{
          font-size: 22px;
        }
      }
      th {
        &.limit{
          width: 10%;
          min-width: 100px;
        }
        &.device_status{
          width: 120px;
        }
        &.device_tariff{
          width: 120px;
        }
      }
    }
  }
}


@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
  }

}
</style>
